/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime (time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.\d{3}/gm), '')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timestr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timestr
}
// 将秒换算为时:分:秒
export function secondConversion (second) {
  // const hh = Math.floor(second / 3600) < 10 ? '0' + Math.floor(second / 3600) : Math.floor(second / 3600)
  // const mm = Math.floor((second / 60 % 60)) < 10 ? '0' + Math.floor((second / 60 % 60)) : Math.floor((second / 60 % 60))
  const mm = Math.floor((second / 60)) < 10 ? '0' + Math.floor((second / 60)) : Math.floor((second / 60))
  const ss = Math.floor((second % 60)) < 10 ? '0' + Math.floor((second % 60)) : Math.floor((second % 60))
  // if (hh * 1 > 0) {
  //   return hh + ':' + mm + ':' + ss
  // } else {
  return mm + ':' + ss
  // }
}
export function parseTimeStr (value) {
  if (typeof value === 'number') {
    const date = new Date(value)
    var day = date.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return `${date.getFullYear()}年${date.getMonth() + 1}月${day}日`
  }
  // 如果value不是数字，则返回原样
  return value
}



// WEBPACK FOOTER //
// ./src/utils/time.js